import { render, staticRenderFns } from "./bg-icon.vue?vue&type=template&id=62985950&"
import script from "./bg-icon.vue?vue&type=script&lang=js&"
export * from "./bg-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports